<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">

    <b-row>

      <t-input v-model="form.name" cols="9" :add-error="error.name" label="Tipo de Item" required/>

      <t-input v-model="form.typeChecklistItemCodeLabel"
               v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
               :add-error="error.typeChecklistItemCodeLabel" upper cols="3"
               label="Cód. Item"
               help="Código inserido manualmente conforme configurado em Checklists > Configurações > Parâmetros"
               required/>

      <t-input v-model="form.typeChecklistItemCodeLabel"
               v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
               :add-error="error.typeChecklistItemCodeLabel" upper cols="3"
               fixed
               label="Cód. Item"
               help="Código inserido automaticamente conforme configurado em Checklists > Configurações > Parâmetros"
      />



    </b-row>

    <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import SettingType from "@/model/types/resource/SettingType";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  name: "TypeChecklistItemDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      SettingType,
      id: "modal-type-checklist-item",
      title: "Cadastro rápido de Item",
      okText: "Incluir Item",
      form: {
        typeChecklistItemId: 0,
        typeChecklistItemNumber: 0,
        typeChecklistItemCodeLabel: "",
        enableAllPathologies:true,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      modeCodeLabel: "",
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.form.enableAllPathologies = true


      await crudGeneral.getAssemble('checklist/type-item', 'list', '')
          .then(response => {

            this.userAuth = response.data;
            this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          });



    },

    async onSubmit() {

      //Validações específicas da tela

      await this.setInsertDialog("checklist/type-item", (item) => {

        this.itemInserted.value = item.typeChecklistItemId
        this.itemInserted.text = this.form.name

        this.successInsert()

      })

    }
  },
  watch:{
    noOptionAdd(){
      this.form.name = this.noOptionAdd
    }
  },

}
</script>
